import { render, staticRenderFns } from "./PaymentPondDetail.vue?vue&type=template&id=56b72d12&scoped=true&"
import script from "./PaymentPondDetail.vue?vue&type=script&lang=js&"
export * from "./PaymentPondDetail.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPondDetail.vue?vue&type=style&index=0&id=56b72d12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b72d12",
  null
  
)

export default component.exports